import type { SideComponentProps } from '@/common/types/app';
import { PageTitle } from '@/components/PageTitle/PageTitle';
import { ReferralsList } from '@/views/Referrals';

const ReferralsPage: SideComponentProps = () => {
  return (
    <>
      <PageTitle title="Client Referrals | Side" />
      <ReferralsList />
    </>
  );
};

ReferralsPage.appShellProps = {
  hideInteractionSidebar: true,
};

ReferralsPage.disableInteractionValidation = true;

export default ReferralsPage;
